const SectionFaq = Class(
	/**
	 * @lends {SectionFaq#}
	 */
	{
		draw() {
			let sections, prefix = '';
			if (D.SITE_B2B) {
				prefix = 'b2b.';
				sections = [
					'corporate.faq',
					'b2b.events.faq',
					'b2b.pricing.faq',
					'gift-card.faq',
					'b2b.for-partners.faq',
					'b2b.contacts.faq',
					'b2b.exp.faq'
				];
			} else {
				sections = [
					'faq',
					'gift-card.faq'
				];
			}
			this.node = mkE({
				tag: 'div',
				id: 'SectionFaq',
				els: [
					{
						tag: 'div',
						className: 'container',
						els: [
							{
								tag: 'div',
								className: 'faq--wrapper',
								attr: {
									itemscope: '',
									itemtype: 'https://schema.org/FAQPage'
								},
								els: [
									{
										tag: 'div',
										className: 'faq--hero mb-5',
										els: [
											{
												tag: 'h1',
												innerHTML: t(`${prefix}faq.h1`)
											},
											{
												tag: 'p',
												innerHTML: t(`${prefix}faq.p`)
											}
										]
									},
									{
										tag: 'div',
										els: (() => {
											let els = [];
											for (let i = 0; i < sections.length; i++) {
												const section = sections[i];
												if (!T.FAQ.hasPrefixQuestions(section)) {
													continue;
												}
												els.push(
													new T.FAQ({
														title: D.Lang.get(`faq.sections.${section}`),
														prefix: `${section}`,
														more: false,
														itemscope: null,
														itemtype: null,
														className: 'mb-5'
													})
												);
											}
											return els;
										})()
									}
								]
							}
						]
					}
				]
			}).append(this.layout.ct());
			this.ready();
		}
	},
	Section
);
